import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import Button from '@material-ui/core/Button'
import CloseIcon from 'react-icons/lib/md/close'
import QuotesListItems from './QuotesListItems'
import Fields from './Fields'

class QuotesList extends React.Component {
  state = { open: false }

  handleOpen = () => this.setState({ open: true })

  handleClose = () => this.setState({ open: false })

  getOffset = (requestUrl) => {
    let offset = requestUrl.search(/offset=/)
    if (offset === -1) return 0
    offset = requestUrl.slice(offset + 7)
    if (offset.search(/&/) === -1) return offset
    offset = offset.slice(offset.search(/&/))
    return offset
  }

  getLimit = (requestUrl) => {
    let limit = requestUrl.search(/limit=/)
    if (limit === -1) return 100 // api default
    limit = requestUrl.slice(limit + 6)
    if (limit.search(/&/) === -1) return 100
    limit = limit.slice(limit.search(/&/))
    return limit
  }

  render() {
    const { state } = this
    const {
      value,
      onChange,
      count,
      next,
      previous,
      results,
      fetchPrevious,
      fetchNext,
      mostRecentRequest,
      selectQuote,
      quoteRef,
      authorRef,
      tagsRef,
    } = this.props

    // const offset = this.getOffset(mostRecentRequest)
    // const limit = this.getLimit(mostRecentRequest)

    return (
      <div className="quotes-list">
        <Typography align="center" style={{ display: 'inline-block' }}>
          {count || 0} quotes loaded &nbsp;
        </Typography>
        {'\u2022'}
        <Button
          className="paperquotes-btn"
          size="small"
          onClick={this.handleOpen}
        >
          PaperQuotes
        </Button>
        <Fields
          value={value}
          onChange={onChange}
          quoteRef={quoteRef}
          authorRef={authorRef}
          tagsRef={tagsRef}
        />
        <div
          className="quotes-list-modal-contentWrapper"
          style={{ display: state.open ? 'block' : 'none' }}
        >
          <div className="quotes-list-content">
            <div className="quotes-list-modal-toolbar">
              <div style={{ float: 'left' }}>
                <div style={{ display: 'inline-block' }}>
                  {/* {' '}
                  Viewing{' '}
                  <span style={{ color: '#ffe600' }}>
                    {offset}-{offset + limit}
                  </span>{' '}
                  of {count} quotes{' '} */}
                  <span style={{ color: '#ffe600' }}>{count} quotes</span>
                </div>
                {' \u2022 '}
                <div style={{ display: 'inline-block' }}>
                  <span
                    className="quotes-list-modal-toolbar-left-previous"
                    onClick={fetchPrevious}
                  >
                    previous
                  </span>
                </div>
                {' \u2022 '}
                <div style={{ display: 'inline-block' }}>
                  <span
                    className="quotes-list-modal-toolbar-left-next"
                    onClick={fetchNext}
                  >
                    next
                  </span>
                </div>
              </div>
              <div className="quotes-list-modal-toolbar-right">
                <CloseIcon
                  onClick={this.handleClose}
                  className="close-modal-icon"
                />
              </div>
            </div>
            <Divider style={{ background: '#fff' }} />
            <QuotesListItems
              results={results}
              selectQuote={selectQuote}
              closeModal={this.handleClose}
            />
          </div>
        </div>
      </div>
    )
  }
}

QuotesList.propTypes = {
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
  next: PropTypes.string,
  previous: PropTypes.string,
  results: PropTypes.array.isRequired,
  selectQuote: PropTypes.func.isRequired,
  fetchPrevious: PropTypes.func.isRequired,
  fetchNext: PropTypes.func.isRequired,
  mostRecentRequest: PropTypes.string.isRequired,
  quoteRef: PropTypes.func.isRequired,
  authorRef: PropTypes.func.isRequired,
  tagsRef: PropTypes.func.isRequired,
}

export default QuotesList



// WEBPACK FOOTER //
// ./src/cms/widgets/QuotePicker/QuotesList.js